export class FiltroCliente {

  nome: string;
  cpfCnpj: string;
  telefone: number;
  cep: string;
}
